import { useContext, useEffect, useRef } from 'react'
import { Button, Col, Form, Row } from "react-bootstrap"
import { useForm } from "react-hook-form"
import { useDispatch } from "react-redux"
import Regex from "../../../Utilities/Regex"
import { PromisedDonerHistoryContext } from '../PromisedDonerComponent'
import { updatePromisedAmountAction } from '../../../Redux/Action/AgentAction'

function PromiseEditForm({ default_data = null }) {

    const btnRef = useRef()
    const dispatch = useDispatch()

    const {
        watch,
        register,
        handleSubmit,
        reset,
        formState: { errors },
        setValue
    } = useForm({
        defaultValues: default_data || {}
    })

    // watch purpose for reactive conditional fields
    const purpose = watch("purpose")

    // reset form when default_data changes (edit mode)
    useEffect(() => {
        if (default_data && Object.keys(default_data).length) {
            reset(default_data)
        }
    }, [default_data, reset])

    // context
    const {
        setPromiseEditModal,
        setPromisedReload
    } = useContext(PromisedDonerHistoryContext)

    const onSubmit = data => {
        const payload = {
            data: {
                ...data,
                promised_collection_id: default_data?.id
            },
            btnRef,
            setPromiseEditModal,
            setPromisedReload
        }

        dispatch(updatePromisedAmountAction(payload))
        // console.log(payload.data)
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="donation">
            <Row>

                {/* Purpose */}
                <Col md={6} sm={12}>
                    <Form.Group className="mb-3">
                        <Form.Label>Purpose</Form.Label>
                        <Form.Select
                            {...register("purpose", {
                                required: true, onChange: () => {
                                    setValue("goods", "")
                                    setValue("quantity", "")
                                }
                            })}
                        >
                            <option value="" disabled>Select</option>
                            <option value="General">General</option>
                            <option value="Orphanage Fund">Orphanage Fund</option>
                            <option value="Other">Other's</option>
                        </Form.Select>

                        {errors.purpose && (
                            <span className="text-danger">
                                Please give purpose
                            </span>
                        )}
                    </Form.Group>
                </Col>

                {/* Conditional fields */}
                {purpose === "Other" && (
                    <>
                        <Col md={6} sm={12}>
                            <Form.Group className="mb-3">
                                <Form.Label>Goods name</Form.Label>
                                <Form.Control
                                    type="text"
                                    {...register("goods")}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={6} sm={12}>
                            <Form.Group className="mb-3">
                                <Form.Label>Quantity</Form.Label>
                                <Form.Control
                                    type="text"
                                    {...register("quantity")}
                                />
                            </Form.Group>
                        </Col>
                    </>
                )}

                {/* Amount */}
                <Col md={6} sm={12}>
                    <Form.Group className="mb-3">
                        <Form.Label>Amount</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="00"
                            {...register("collection_amount", {
                                min: {
                                    value: 500,
                                    message: "Minimum amount is 500"
                                },
                                pattern: Regex.numeric()
                            })}
                        />

                        {errors.collection_amount && (
                            <span className="text-danger">
                                {errors.collection_amount.message || "Invalid amount"}
                            </span>
                        )}
                    </Form.Group>
                </Col>

            </Row>

            <Button
                ref={btnRef}
                variant="primary"
                type="submit"
                className="submit"
            >
                Submit
            </Button>
        </form>
    )
}

export default PromiseEditForm
